export const phoneNumberMutationSitecoreLabels = {
  HeadingOldPhoneNumber: { value: "Huidig telefoonnummer" },
  InfoOldPhoneNumber: { value: "Optioneel" },
  PlaceholderOldPhoneNumber: { value: "Huidig telefoonnummer" },
  TooltipOldPhoneNumber: { value: "" },
  HeadingNewPhoneNumber: { value: "Nieuw telefoonnummer" },
  InfoNewPhoneNumber: { value: "" },
  PlaceholderNewPhoneNumber: { value: "Nieuw telefoonnummer" },
  TooltipNewPhoneNumber: { value: "" },
};
